import { Component } from '@angular/core';

import { SuburbPlace } from '../../../../services/locations.service';
import { kindLabel } from '../places/place-kinds';
import { placeMarkerState } from '../places/place-list';
import { PanelNavService } from '../workspace/panel-nav.service';
import { SuburbPlacesService } from '../workspace/suburb-places.service';
import { WorkspaceStateService } from '../workspace/workspace-state.service';

/**
 * A suburb's Places tab (#253 step 3): the crawl's places in the suburb, also drawn on the map, filtered by type and
 * name; a row opens the place's panel, and its buttons put it on the website or add it to Conductor in one click.
 * "Add a place" adds one that isn't in the crawl.
 */
@Component({
  selector: 'app-suburb-places-tab',
  templateUrl: './suburb-places-tab.component.html',
  styleUrls: ['./suburb-places-tab.component.scss'],
})
export class SuburbPlacesTabComponent {
  readonly kindLabel = kindLabel;

  constructor(
    public state: WorkspaceStateService,
    public places: SuburbPlacesService,
    public nav: PanelNavService
  ) {}

  /** A row's dot class, for a place that has no icon: its marker's colour (map-style.ts). */
  dotClass(p: SuburbPlace): string {
    return 'pd-' + placeMarkerState(p);
  }

  addToWebsite(p: SuburbPlace, ev: Event): void {
    ev.stopPropagation();
    this.places.addToWebsite(p);
  }

  /** Add to Conductor runs the dedupe gate, so it opens the place's popup and adds from there (at once when nothing looks like it). */
  addToConductor(p: SuburbPlace, ev: Event): void {
    ev.stopPropagation();
    this.places.openPopup(p.locationId, true);
  }

  trackPlace(_i: number, p: SuburbPlace): number {
    return p.locationId;
  }
}
